import React from 'react'
import { Switch, Route } from 'react-router-dom'
import cx from 'classnames'

import { Flow } from 'constants/flowConstants'

import SignupCard from 'layouts/SignupCard'
import VideoSuccessStep from 'layouts/VideoSuccessStep'
import VideoInstallStep from 'layouts/VideoInstallStep'
import VideoLandingStep from 'layouts/VideoLandingStep'
import TrackWebstoreReferrer from 'layouts/TrackWebstoreReferrer'
import VideoExtensionLoginRedirect from 'layouts/VideoExtensionLoginRedirect'
import VideoProcessThirdPartySignup from 'layouts/VideoProcessThirdPartySignup'
import VideoSurveyStep from 'layouts/VideoSurveyStep'

import graffitiTextureDesktop from './graffiti-texture-desktop.svg'
import graffitiTextureDesktop2 from './graffiti-texture-desktop-2.svg'
import driftVideoSrc from '../../images/drift-video-logo.png'

import './style.css'

const VideoController = ({ loginUrl }) => {
  const showCardLayout = window.location.pathname.includes('/video/start') || window.location.pathname.includes('/video/survey')

  const accessType = window.localStorage.getItem('hyfy_account_referrer') || ''
  let installVariant = 'marketing'

  if (accessType.includes('drift.com/powered') || accessType.includes('video_cta')) {
    installVariant = 'powered-by'
  } else if (accessType === 'app-switcher' || accessType === 'nav_icon') {
    installVariant = 'app-switcher'
  }

  return (
    <div className={cx('video-setup-container', `${installVariant}-variant`, { 'video-signup-background': showCardLayout })}>
      <img className="video-setup-background-left" src={graffitiTextureDesktop} alt="" />
      <img className="video-setup-background-right" src={graffitiTextureDesktop2} alt="" />
      {!showCardLayout && (
        <div className="video-logo-container">
          <img className="video-logo-image" src={driftVideoSrc} alt="Drift Video"/>
        </div>
      )}
      <div className="video-setup-content">
        <Switch>
          <Route exact path="/video/start" render={() => <SignupCard flow={Flow.VIDEO} loginUrl={loginUrl}/>} />
          <Route exact path="/video/select/google" component={VideoProcessThirdPartySignup} />
          <Route exact path="/video/select/microsoft" component={VideoProcessThirdPartySignup} />
          <Route exact path="/video/success" component={VideoSuccessStep} />
          <Route exact path="/video/extension" render={() => <VideoInstallStep installVariant={installVariant}/>} />
          <Route exact path="/video/landing" component={VideoLandingStep} />
          <Route exact path="/video/track-webstore-referrer" component={TrackWebstoreReferrer} />
          <Route exact path="/video/extension-login" component={VideoExtensionLoginRedirect} />
          <Route exact path="/video/survey" component={VideoSurveyStep} />
          <Route path="/" render={() => <SignupCard flow={Flow.VIDEO} loginUrl={loginUrl}/>} />
        </Switch>
      </div>
    </div>
  )
}

export default VideoController



// WEBPACK FOOTER //
// ./src/layouts/VideoController/component.js